var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#0480C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 14.75C22.1695 14.75 18.25 18.2779 18.25 22.625C18.25 29.625 27 39.25 27 39.25C27 39.25 35.75 29.625 35.75 22.625C35.75 18.2779 31.8305 14.75 27 14.75ZM27 27C26.3078 27 25.6311 26.7947 25.0555 26.4101C24.4799 26.0256 24.0313 25.4789 23.7664 24.8394C23.5015 24.1999 23.4322 23.4961 23.5673 22.8172C23.7023 22.1383 24.0356 21.5146 24.5251 21.0251C25.0146 20.5356 25.6383 20.2023 26.3172 20.0673C26.9961 19.9322 27.6999 20.0015 28.3394 20.2664C28.9789 20.5313 29.5256 20.9799 29.9101 21.5555C30.2947 22.1311 30.5 22.8078 30.5 23.5C30.499 24.4279 30.1299 25.3176 29.4738 25.9738C28.8176 26.6299 27.9279 26.999 27 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location-1.32d689e3eba38b9969095c6a476ec0e0.svg";
export { ForwardRef as ReactComponent };